import React from 'react';
import ArticleMobileLinks from './article-mobile-links';
import MainLinks from './main-links';

const LinksBar = ({ location, videoCode, audioUrl, LinksBarProps, LinksBarArticleMobileProps }) => (
  <div className="site-header__links-inner">
    {location === 'single-article--article' && (videoCode || audioUrl) ? (
      <>
        <ArticleMobileLinks props={LinksBarArticleMobileProps} />
        <MainLinks props={LinksBarProps} />
      </>
    ) : (
      <MainLinks props={LinksBarProps} />
    )}
  </div>
);

export default LinksBar;
